// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"Banner_imgWrapper__FWvWb","img":"Banner_img__mXAgd"};